/* src/app/components/storage-account-down-toast/storage-account-down-toast.component.scss */
:host {
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
}
:host .storage-account-down-toast {
  background-color: #FFD100;
  height: 42px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
:host .storage-account-down-toast .message {
  font-weight: 700;
  font-size: 14px;
  color: #212121;
}
/*# sourceMappingURL=storage-account-down-toast.component.css.map */
